import { render, staticRenderFns } from "./BaseActionsGrouped.vue?vue&type=template&id=c6e2d968"
import script from "./BaseActionsGrouped.vue?vue&type=script&lang=ts"
export * from "./BaseActionsGrouped.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports